"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const assessment_serializer_1 = require("../serializers/assessment.serializer");
const sdk_constants_1 = require("../../constants/sdk.constants");
const date_helper_1 = require("../../helpers/date.helper");
const assessment_partial_serializer_1 = require("../serializers/assessment-partial.serializer");
class AssessmentClient {
    static newInstance(options, retryOptions) {
        return new AssessmentClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new assessment_serializer_1.AssessmentSerializer(), new assessment_partial_serializer_1.AssessmentPartialSerializer());
    }
    constructor(client, serializer, assessmentPartialSerializer) {
        this.client = client;
        this.serializer = serializer;
        this.assessmentPartialSerializer = assessmentPartialSerializer;
    }
    async findOneById(id, assigneeId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments/${id}`, {
            headers,
            params: { assigneeId },
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async countByStatus(contextId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.countByStatus`, {
            params: { contextId },
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeAssessmentStatusCount(data);
    }
    async findStatusSummary(headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.findStatusSummary`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeStatusSummary(data);
    }
    async findByUser(filters, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.findByUser`, {
            headers,
            params: { ...filters, ...pageableOptions },
        });
        return response.body.data.map((assessment) => this.assessmentPartialSerializer.serializeOne(assessment));
    }
    async findByOwner(ownerId, filters, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.findByOwner`, {
            headers,
            params: { ownerId, ...filters, ...pageableOptions },
        });
        return this.serializer.serialize(response.body);
    }
    async findByAssignee(assigneeId, filters, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.findByAssignee`, {
            headers,
            params: { assigneeId, ...filters, ...pageableOptions },
        });
        return this.serializer.serialize(response.body);
    }
    async assign(assessmentTemplateId, assignments, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.assign`, {
            assessmentTemplateId,
            assignments: assignments.map(({ startDate, endDate, ...rest }) => {
                return {
                    ...rest,
                    startDate: (0, date_helper_1.toUtc)(startDate),
                    endDate: (0, date_helper_1.toUtc)(endDate),
                };
            }),
        }, {
            headers,
        });
        const { data } = response.body;
        return data.map((item) => this.serializer.serializeOne(item));
    }
    async reassign(reassign, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.reassign`, {
            assessmentId: reassign.assessmentId,
            autoLaunch: reassign.autoLaunch,
            endDate: (0, date_helper_1.toUtc)(reassign.endDate),
            startDate: (0, date_helper_1.toUtc)(reassign.startDate),
            assigneeIds: reassign.assigneeIds,
            settings: reassign.settings,
            totalClassStudents: reassign.totalClassStudents,
        }, {
            headers,
        });
    }
    async reopen(reopenAssessmentDto, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.reopen`, {
            assessmentId: reopenAssessmentDto.assessmentId,
            endDate: (0, date_helper_1.toUtc)(reopenAssessmentDto.endDate),
            assigneeIds: reopenAssessmentDto.assigneeIds,
            startDate: reopenAssessmentDto.startDate ? (0, date_helper_1.toUtc)(reopenAssessmentDto.startDate) : undefined,
        }, {
            headers,
        });
    }
    async open(assessmentId, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.open/${assessmentId}`, {}, {
            headers,
        });
    }
    async delete(assessmentId, headers) {
        await this.client.delete(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments/${assessmentId}`, {
            headers,
        }, {});
    }
    async finish(assessmentId, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.finish/${assessmentId}`, {}, {
            headers,
        });
    }
    async stop(assessmentId, headers) {
        await this.client.put(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.stop/${assessmentId}`, {}, {
            headers,
        });
    }
    async reschedule(reschedule, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/assessments.reschedule`, {
            assessmentId: reschedule.assessmentId,
            autoLaunch: reschedule.autoLaunch,
            endDate: (0, date_helper_1.toUtc)(reschedule.endDate),
            startDate: (0, date_helper_1.toUtc)(reschedule.startDate),
            assigneeIds: reschedule.assigneeIds,
            scorePolicy: reschedule.scorePolicy,
        }, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
}
exports.AssessmentClient = AssessmentClient;
//# sourceMappingURL=assessment.client.js.map